<script>
  import { CtaContainer } from "./CtaButton.style";
  import BaseButton from "../../components/BaseButton/BaseButton.svelte";
  import RightArrow from "../../svg/RightArrow.svelte";

  import { css } from "emotion";

  export let link;

  const handleOnClick = () => {
    window.location.href = link;
    console.log(link);
  };
</script>

<div class={CtaContainer}>
  <BaseButton
    on:click={handleOnClick}
    style={css`
      max-width: 340px;
      font-size: 13px;`}>
    BELI SEKARANG
    <RightArrow />
  </BaseButton>
</div>
